import { Injectable } from "@angular/core";
import { AuthenticationService } from "app/helpers/authentication.service";

@Injectable({
    providedIn: "root"
})

export class EnumService {

    nomeStatus: string = 'AGUARDANDO ERP';
    nomeStatus2: string = 'PERSONALIZADO';
    public nomeStatusDespesa: string = '';
    public statusPedido: any[] = [];
    public statusOferta: any[] = [];
    public statusLancamentoDespesa: any[] = [];

    constructor(
        private _authenticationService: AuthenticationService
    ){

        let regras = this._authenticationService.getRegras();
        let aux;

        // REGRA PARA OS STATUS 12 PEDIDO
        aux = regras.find(res => res.RoleNumber == "13-70");
        if (aux != undefined && aux.Value != undefined) {
            this.nomeStatus = aux.Value.toUpperCase();
        }

        // REGRA PARA OS STATUS 15 LANÇAMENTO DESPESA
        aux = regras.find(res => res.RoleNumber == "7-19");
        if (aux != undefined && aux.Value != undefined) {
            this.nomeStatusDespesa = aux.Value;
        }

        let objStatus = [
            {id: 1, text: 'ORÇAMENTO', value: 0},
            {id: 2, text: 'PEDIDO', value: 1},
            {id: 3, text: 'ENVIANDO', value: 2},
            {id: 4, text: 'AGUARDANDO ANÁLISE', value: 3},
            {id: 5, text: 'APROVADO', value: 4},
            {id: 6, text: 'FATURADO PARCIAL', value: 5},
            {id: 7, text: 'FATURADO TOTAL', value: 6},
            {id: 8, text: 'REPROVADO', value: 7},
            {id: 9, text: 'NÃO SINCRONIZADO', value: 8},
            {id: 10, text: 'CANCELADO', value: 9},
            {id: 11, text: 'VENDA FUTURA PARCIAL', value: 10},
            {id: 12, text: 'VENDA FUTURA TOTAL', value: 11},
            {id: 13, text: this.nomeStatus, value: 12},
            {id: 14, text: 'AGUARDANDO APROVAÇÃO', value: 16},
            {id: 15, text: 'EM ANÁLISE', value: 17},
            {id: 16, text: 'PENDENTE ANÁLISE', value: 18},
        ];
       


        // REGRA PARA OS STATUS 13, 14 e 15
        aux = regras.find(res => res.RoleNumber == "13-71");
        if (aux != undefined && aux.Value != undefined) {
            objStatus = [
                {id: 1, text: 'ORÇAMENTO', value: 0},
                {id: 2, text: 'PEDIDO', value: 1},
                {id: 3, text: 'ENVIANDO', value: 2},
                {id: 4, text: 'AGUARDANDO ANÁLISE', value: 3},
                {id: 5, text: 'APROVADO', value: 4},
                {id: 6, text: 'FATURADO PARCIAL', value: 5},
                {id: 7, text: 'FATURADO TOTAL', value: 6},
                {id: 8, text: 'REPROVADO', value: 7},
                {id: 9, text: 'NÃO SINCRONIZADO', value: 8},
                {id: 10, text: 'CANCELADO', value: 9},
                {id: 11, text: 'VENDA FUTURA PARCIAL', value: 10},
                {id: 12, text: 'VENDA FUTURA TOTAL', value: 11},
                {id: 13, text: this.nomeStatus, value: 12},
                {id: 13, text: 'PREVISÃO DE ENTREGA', value: 13},
                {id: 13, text: 'MERCADORIA ENTREGUE', value: 14},
                {id: 13, text: 'MERCADORIA A CAMINHO', value: 15},
                {id: 14, text: 'AGUARDANDO APROVAÇÃO', value: 16},
                {id: 15, text: 'EM ANÁLISE', value: 17},
                {id: 16, text: 'PENDENTE ANÁLISE', value: 18},
            ];
        }

        // REGRA PARA OS STATUS 19
        aux = regras.find(res => res.RoleNumber == "13-84");
        if (aux != undefined && aux.Value != undefined) {
            this.nomeStatus2 = aux.Value.toUpperCase();
            objStatus.push({id: 17, text: this.nomeStatus2.toUpperCase(), value: 19});
        }

        this.statusPedido = objStatus;

        this.statusOferta = [
            {id: 1, text: 'PENDENTE', value: 0},
            {id: 2, text: 'EM ANÁLISE', value: 1},
            {id: 3, text: 'APROVADO', value: 2},
            {id: 4, text: 'PEDIDO', value: 3},
            {id: 5, text: 'REPROVADO', value: 4},
            {id: 6, text: 'CANCELADO', value: 5},
        ];

        this.returnStatusPedido();


        this.statusLancamentoDespesa = [
            {id: 1, text: 'Pendente', value: 0},
            {id: 2, text: 'Aprovado', value: 1},
            {id: 3, text: 'Reprovado', value: 8},
        ];

        if(this.nomeStatusDespesa != ""){ // Validação da Regra 7-19
            this.statusLancamentoDespesa = [
                {id: 1, text: 'Pendente', value: 0},
                {id: 4, text: this.nomeStatusDespesa, value: 15},
                {id: 2, text: 'Aprovado', value: 1},
                {id: 3, text: 'Reprovado', value: 8},
                
            ];
        } 
    }

    returnStatusPedido(){
        return this.statusPedido;
    }

    returnStatusOferta(){
        return this.statusOferta
    }
}

export enum statusPrevisao {
    'Previsto' = 0,
    'Concluido' = 1,
    'Cancelado' = 9,
}

export enum nivelTecnologico {
    'Menor' = 0,
    'Médio' = 1,
    'Alto' = 2
}

export enum StatusPipeline {
    'Em andamento' = 1, //azul
    'Vendida' = 2, //verde
    'Perdida' = 3 //vermelho
}

export enum ControleAtividadesPipelime {
    'Sem Atividades Pendentes' = 1,
    'Com Atividades Pendentes' = 2,
    'Com Atividades Atrasadas' = 3,
}
    
export enum StatusAtividade{    
    'PENDENTE' = 1,
    'ANDAMENTO' = 2,
    'CONCLUÍDO' = 3,
    'CANCELADO' = 9, 
}

export enum StatusAssinaturaAtividade {
    /* 'Todos' = 0, */
    'Pronto para ser Enviado' = 1,
    'Enviado para Assinatura' = 2,
    'Assinado' = 3,
    'Em Análise' = 4,
    'Conferido' = 5,
}

export enum TipoRespostaForm {
    'Resposta Curta' = 1,
    'Paragráfo' = 2,
    'Data' = 3,
    'Anexo' = 4,
    'Múltipla Escolha' = 5,
    'Caixa de Seleção' = 6,
    'Lista Suspensa' = 7,
}

export enum TipoErps {    
    Nenhum = 9,
    B1 = 1,
    ContaAzul = 2,
    Gerencial = 3,
    Siagri = 4, 
    Sankhya = 5,
    Omie = 6,
    'S4-Hana' = 7,
    Senior = 8,
    Agrodados = 10,
}

export enum EnumCodigoIncoterms {
    'Contratação do Frete por conta do Remetente (CIF)' = 0,
    'Contratação do Frete por conta do Destinatário (FOB)' = 1,
    'Contratação do Frete por conta de Terceiros' = 2,
    'Transporte Próprio por conta do Remetente' = 3,
    'Transporte Próprio por conta do Destinatário' = 4,
    'Sem Ocorrência de Transporte' = 9,
}

export enum EnumStatusCadastroBase {
    Ativo       = 1,
    Inativo     = 0,
    Deletado    = 9
}


export enum EnumStatusRelatorioDespesa {
    Pendente    = 0,
    Concluído   = 1,
    Aprovado    = 2, 
    Fechado	    = 3,
    Reprovado	= 8, 
    Cancelado   = 9 
}

export enum EnumTipoCadastroVinculo {
    'Tipo de Despesa' = 0,
    'Tipo de Pagamento' = 1,
    'Grupo de Usuário' = 2,
}

export enum EnumBillingType	{
    'PorUsuario' = 1,
    'PorFaixaUsuario' = 2,
    'PorLicensa' = 3,
    'PorBancoDados' = 4,
    'SemCobranca' = 5,
    'EmDefinicao' = 6
}

export enum EnumRoleType {
    'PorConta' = 1,
    'PorFilial' = 2,
    'PorGrupoProduto' = 3,
    'PorGrupoUsuario' = 4,
    'PorUsuario' = 5
}

export enum EnumUserType {
    'Administrador' = 0,
    'Gestor' = 1,
    'Supervisor' = 2,
    'Vendedor' = 3,
    'Cliente' = 4
}

export enum EnumType{
    'ENUM' = 1,
    'TEXTO' = 2,
    'BOOLEAN' = 3,
}

export enum EnumFuncoes {
    'Administrador' = 'Administrador',
    //'Armazenagem' = 'Armazenagem', removido
    'Cliente' = 'Cliente',
    'DistribuidorLojista' = 'Distribuidor/Lojista',
    'Financeiro' = 'Financeiro',
    'Gestor' = 'Gestor',
    'GestorRDV' = 'Gestor RDV',
    'RDV' = 'RDV',
    'TI' = 'TI',
    'VendedorBalcão' = 'Vendedor Balcão', 
    'VendedorCampo' = 'Vendedor Campo',   
}

export const FuncoesApelidos: Record<EnumFuncoes, string> = {
  [EnumFuncoes.Administrador]: 'Administrador',
  [EnumFuncoes.Cliente]: 'Cliente',
  [EnumFuncoes.DistribuidorLojista]: 'Distribuidor',
  [EnumFuncoes.Financeiro]: 'Financeiro',
  [EnumFuncoes.Gestor]: 'Gestor Comercial',
  [EnumFuncoes.GestorRDV]: 'Gestor RDV',
  [EnumFuncoes.RDV]: 'Usuário RDV',
  [EnumFuncoes.TI]: 'TI',
  [EnumFuncoes.VendedorBalcão]: 'Usuário CRM',
  [EnumFuncoes.VendedorCampo]: 'Consultor'
};

export enum EnumTipoProduto {
    'Produto' = 1,
    'ProdutoSubstituto' = 2,    
}

export enum FormaPagtSaldoExtratoRDV {
    'Crédito' = 1,
    'Débito' = 2,
}

export enum EnumVariaveisMetas{
    'Produto' = 1,
	'Cliente' = 2,
	'Vendedor' = 3,
	'GrupodeProduto' = 4,
	'ProdutoSubstituto' = 5,
	'Cultura' = 6,
    'Safra' = 7,
    'Mostrar Dados' = 8,
    'PNAgrupador' = 9,
    'Regiao' = 10,
    'Marca' = 11,
    'VariavelGenerica' = 12
}

export enum EnumCategoriasFunil {
    Orcamento    = 1,
    AguardandoAnalise   = 2,
    Aprovado    = 3, 
    VendaFutura = 4,
    Faturado    = 5, 
}

export enum OperacaoExtratoRDV {
    'Entrada' = 1,
    'Saída' = 2,
}

export enum TipoRegraSemaphore {
    PorProduto = 1,
    PorGrupoProduto = 2,
    Geral = 3
}

export enum EnumCorSemaphore {
    green = 1,
    yellow = 2,
    red = 3
}

export enum FiltrosListaPreco{
    'Condições de Pagamentos (CondPagto)' = 1,
    'Empresa' = 2,
    'Estado/UF' = 3,
    'Grupo de Produto' = 4,
    'Parceiro de Negócio' = 5,
    'Produto' = 6,
    'Tipo de Cliente' = 7,
    'Tipo de Negociação' = 8,
    'Vendedor' = 9,
}

export enum ModalidadeAdiantamento{
    Esporádico = 1,
    Fixo = 2
}

export enum EnumStatusAdiantamento {
    PENDENTE = "0",
    LIBERADO = "1",
    APROVADO =  "2, 3, 4",
    REPROVADO = "5",
    CONCLUIDO = "6",
    "SALDO DEVIDO" = "7",
    "PENDENTE DE REEMBOLSO" = "8"
}

export enum EnumNoticacoes {
    SEM_NOTIFICACOES = 1,
    TODAS_NOTIFICACOES = 2,
    NOTIFICACOES_GESTOR_ADMINISTRADOR = 3,
    NOTIFICACOES_GESTOR = 4,
}     

export enum NoticacoesModulePedidos {
    SEM_NOTIFICACOES = 1,
    TODAS_NOTIFICACOES = 2,
    NOTIFICACOES_GESTOR = 3,
}

export enum EnumStatusNotaFiscal {
    "NF EMITIDA" = 1,
    "DEVOLUÇÃO DE VENDA" = 2,
    "NF CANCELADA" = 0
}

export enum EnumTipoCliente {
    'Cliente' = 1,
    'Lead' = 2
}
export enum EnumCamposObrigatoriosPlanilha {
    "Endereço" = "ativo, codigo_parceiro_negocio, endereco, numero, bairro, cidade, uf, cep",
    "Grupo de Produto" = "codigo, ativo, descricao",
    "Lista de Preço" = "codigo, ativo, nome",
    "Lista de Preço Filtro" = "",
    "Preço Produto" = "ativo, codigo_produto, codigo_lista_preco",
    "Parceiro de Negocio" = "codigo, ativo, razao_social, cnpj, cpf",
    "Parceiro Negocio x Região" = "codigo_parceiro_negocio, id_regiao",
    "Parceiro Negocio x Vendedor" = "codigo_parceiro_negocio, codigo_vendedor",
    "Produto" = "codigo, ativo, descricao, codigo_grupo_produto, codigo_unidade_medida, peso_unidade_medida_venda, unidade_medida_venda",
    "Vendedor" = "codigo, ativo, nome_vendedor, comissao_venda",
}

export enum ConfiguracaoParcelaCondPagto {
    numeroDeDia = 1,
    dataFixa = 2,
    diaFixo = 3,
}

export function EnumtoArrayText(enumm): any[] {
    return Object.keys(enumm)
      .map(key => ({
        text: key,  
        value: enumm[key]  
      }));
}

export function EnumtoArray(enumm): any[] {
    return Object.keys(enumm)
                  .filter(k => typeof enumm[k] === 'number')
                  .map(text => ({ text, value: enumm[text] }));
}